module.exports = __webpack_public_path__ + "static/img/start_bg.42cdea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/start_bg.jpg
// module id = XKr3
// module chunks = 2